module.exports = __webpack_public_path__ + "static/media/03.a68b1c33.png";